import { useCloseSidePanel } from '@/ui/layout/side-panel/hooks/useCloseSidePanel';
import { SIDE_PANEL_HOTKEY_LAYERS } from '@/ui/layout/side-panel/constants/SidePanelHotkeyLayers';
import { useGlobalHotkeys } from '@/ui/utilities/hotkey/hooks/useGlobalHotkeys';

// Mounted only while the panel is open.
export const SidePanelHotkeyEffect = () => {
  const { closeSidePanel } = useCloseSidePanel();

  useGlobalHotkeys({
    keys: 'escape',
    callback: closeSidePanel,
    activeOnLayers: SIDE_PANEL_HOTKEY_LAYERS,
  });

  return null;
};
